export default "<p>merchants works!</p>\n"